import { blogPreset } from '@next-adapter/presets/blog/preset.js'
import { portfolioPreset } from '@next-adapter/presets/portfolio/preset.js'
import type { BetterstartPresetDefinition, BetterstartPresetId } from '@preset-engine/types.js'

export const presetRegistry: Record<string, BetterstartPresetDefinition> = {
  blog: blogPreset,
  portfolio: portfolioPreset
}

export function listPresetDefinitions(): BetterstartPresetDefinition[] {
  return Object.values(presetRegistry)
}

export function getPresetDefinition(presetId: BetterstartPresetId): BetterstartPresetDefinition {
  const definition = presetRegistry[presetId]
  if (!definition) {
    throw new Error(formatUnknownPresetMessage([presetId]))
  }
  return definition
}

export function isPresetId(value: string): value is BetterstartPresetId {
  return value in presetRegistry
}

export function formatUnknownPresetMessage(presetIds: string[]): string {
  return `Unknown preset(s): ${presetIds.join(', ')}. Available for next: ${Object.keys(presetRegistry).join(', ')}`
}
